import { Component, OnInit, Inject } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { sessionStorage } from 'src/app/localstorage.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import * as moment from 'moment';
import { DialogComponent } from '../dialog.component';
import { log } from 'util';

@Component({
  selector: 'app-redeem-status-modal',
  templateUrl: './redeem-status-modal.component.html',
  styleUrls: ['./redeem-status-modal.component.scss']
})
export class RedeemStatusModalComponent implements OnInit {
  savingFlag: boolean = false;
  segment: any = {};
  category: any = {};
  login: any = {};
  drlist:any =[]
  report_manager:any =[];
  delivery_from: any;
  userData: any;
  userId: any;
  userName: any;
  user_id: any;
  purchase_id: any;
  today_date: any;
  otpFlag:boolean = false;
  
  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialog: MatDialog, public serve: DatabaseService, public session: sessionStorage, public toast: ToastrManager,public alert : DialogComponent , public dialogRef: MatDialogRef<RedeemStatusModalComponent>) {
    this.userData = JSON.parse(localStorage.getItem('st_user'));
    console.log('====================================');
    console.log(data);
    this.purchase_id = this.data.id;
    console.log(this.purchase_id);
    
    console.log('====================================');
    this.today_date = new Date();
    this.segment = this.data.segment;
    // this.delivery_from = this.data.delivery_from;
    this.userId = this.userData['data']['id'];
    this.userName = this.userData['data']['name'];
    this.delivery_from = this.data.delivery_from;
    // this.data.assigned_to_user_id=this.data.assigned_to_user_id.toString();
    console.log( 'user_id',this.data.assigned_to_user_id);
    this.user_id = this.data.user_id;
    if(data.delivery_from != 'purchase_status'){
      this.getSalesUser('')
      this.distributorList('','');

    }

    if(data.delivery_from == 'purchase_status_update'){
      this.getProduct('')
    }
 
    if(this.data.delivery_from  == 'redeem_status'){
      this.data.order_status = this.data.gift_status;
    }
    if(this.delivery_from == 'redeem_status'){
      this.getUserEarnPoints();
    }

    if(this.data.delivery_from == 'lead_detail_assign_user'){
      this.getReportManager('');
    }
   
  }
  
  ngOnInit() {
    this.login = JSON.parse(localStorage.getItem('login'));
  }

  getOtp() {
    if((this.data.redeem_type == 'Cash' && (this.transform(this.data.cash_amount) > this.transform(this.userData.organisation_data.payout_per_transaction_limit)))){
      this.toast.errorToastr('Maximum per transaction allowed amount  ₹' +this.userData.organisation_data.payout_per_transaction_limit);
      return
    }

    this.data.verify_otp = Math.floor(100000 + Math.random() * 900000);
    this.serve.post_rqst({'mobile': this.userData['organisation_data']['payout_transaction_mobile'], 'otp':this.data.verify_otp}, "RedeemRequest/verifyOtp").subscribe((result => {
      if(result['statusCode'] == 200){
        this.otpFlag = true;
      }
      else{
        this.toast.errorToastr(result['statusMsg'])
      }

    }))

  }

  
  transform(value: number): number {
    return Number(value);
  }
 
   otpvalidation() {
    if(this.data.otp.length == 6){
      if (this.data.otp != this.data.verify_otp) {
        this.toast.errorToastr('Invaild OTP');
      }
    }
  }

  reason_reject: any
  redeem_status_change(reason, status) {
    this.savingFlag = true;
    this.serve.post_rqst({ 'status': status, 'id': this.data.id, 'created_by_id':this.userId, 'created_by_name':this.userName, 'reject_reason': reason }, "RedeemRequest/redeemRequestStatusChange").subscribe((result => {
      if (result['statusCode'] == 200){
        this.dialogRef.close(true);
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }
      
    }))
    
  }


  updateNumber() {
    this.savingFlag = true;
    this.serve.post_rqst({ 'wallet_number': this.data.wallet_number, 'id': this.data.id, 'created_by_id':this.userId, 'created_by_name':this.userName}, "RedeemRequest/saveWalletNumber").subscribe((result => {
      if (result['statusCode'] == 200){
        this.dialogRef.close(true);
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }
      
    }))
    
  }


  findUser(id){
    let index=  this.report_manager.findIndex(row=>row.id==id)
    if(index!= -1){
      this.data.user_name= this.report_manager[index].name;
    }
  }

  site_status_change1(data) {
    console.log('====================================');
    console.log(data);
    console.log('====================================');
        this.savingFlag = true;
    
          this.serve.post_rqst({ 'assigned_to_user_id': data.assigned_to_user_id, 'id':this.data.id, 'assigned_to_user_name':  data.assigned_to_user_name}, "Enquiry/reassignedUser").subscribe((result => {
            if (result['statusCode'] == 200) {
              this.dialog.closeAll();
              this.savingFlag = false;
              this.toast.successToastr('Status Changed Successfully');
            }
            else {
              this.toast.errorToastr(result['statusMsg']);
              this.savingFlag = false;
            }
    
          }))
      }

  salesUser:any =[];
  getSalesUser(searcValue) {
    this.serve.post_rqst({'search':searcValue}, "influencer/salesUserList").subscribe((response => {
      
      if (response['statusCode'] == 200) {
        this.salesUser = response['all_sales_user'];
      }
      else {
        this.toast.errorToastr(response['statusMsg']);
      }
      
    }));
  }

  getReportManager(searcValue) {
    this.serve.post_rqst({'search':searcValue}, "Enquiry/getSalesUserForReporting").subscribe((response => {
      if(response['all_sales_user']['statusCode'] == 200){
        this.report_manager = response['all_sales_user']['all_sales_user'];
        // this.data.assigned_to_user_id=this.data.assigned_to_user_id
      }
      else{
        this.toast.errorToastr(response['all_sales_user']['statusMsg']);
      }
    }));
  }

  distributorList(searcValue, state) {
    this.serve.post_rqst({'search':searcValue, 'state':state}, "influencer/distributorsList").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.drlist = result['distributors'];
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
      }
      
    }))
  }
  influencer_status_change(reason, status) {
    this.savingFlag = true;
    if(status == 'Approved'){
      this.alert.confirm('Are you sure ?').then((result) => {
        if (result) {
          this.serve.post_rqst({ 'status': status, 'influencer_id': Number(this.data.id),'welcome_bonus_flag': Number(this.data.welcome_bonus_flag), 'created_by':Number(this.userId) ,'distributor_id':this.data.distributor_id,'referred_by':this.data.referred_by_id,'name':this.data.name,'influencer_type':this.data.influencer_type}, "Influencer/influencerStatusChange").subscribe((result => {
            if (result['statusCode'] == 200) {
              this.dialogRef.close(true);
              this.savingFlag = false;
              this.toast.successToastr('Status Changed Successfully');
            }
            else {
              this.toast.errorToastr(result['statusMsg']);
              this.savingFlag = false;
            }
            
          }))
        }
      });
    }else{
      this.serve.post_rqst({ 'status': status, 'influencer_id': Number(this.data.id), 'welcome_bonus_flag': Number(this.data.welcome_bonus_flag), 'created_by':Number(this.userId) ,'reject_reason': reason,'referred_by':this.data.referred_by_id,'name':this.data.name,'influencer_type':this.data.influencer_type}, "Influencer/influencerStatusChange").subscribe((result => {
        
        if (result['statusCode'] == 200) {
          this.dialogRef.close(true);
          this.savingFlag = false;
          this.toast.successToastr('Status Changed Successfully');
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.savingFlag = false;
        }
        
      }))
    }
  }
  
  
  gift_status_change(header) {
    this.serve.post_rqst(header, 'RedeemRequest/redeemRequestGiftStatusChange').subscribe((result => {
      if (result['statusCode'] == 200){
        this.dialog.closeAll();
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }
    }))
  }
  
  updateStatus(status) {
    this.data.estimate_date = moment(this.data.estimate_date).format('YYYY-MM-DD')
    this.data.transfer_date = moment(this.data.transfer_date).format('YYYY-MM-DD')
    this.savingFlag = true;
    let header = {}
    if (status == 'Under Process' || status == 'Received') {
      header = { 'status': status, 'id': this.data.id }
      this.gift_status_change(header)
    } else if (status == 'Shipped') {
      
      header = { 'status': status, 'id': this.data.id, 'shipping_remark': this.data.Shipped_remark, 'shipping_type': this.data.shipping_type, 'estimate_date': this.data.estimate_date }
      this.gift_status_change(header)
    } else if (status == 'Transferred') {
      header = { 'status': status, 'id': this.data.id, 'payment_mode': this.data.transfer_mode, 'transfer_date': this.data.transfer_date, "transfer_remark": this.data.transfer_remark, 'transaction_no': this.data.transaction_number }
        this.gift_status_change(header)
      // if (this.data.transfer_mode == 'Online') {
      //   header = { 'status': status, 'id': this.data.id, 'payment_mode': this.data.transfer_mode, 'transfer_date': this.data.transfer_date, "transfer_remark": this.data.transfer_remark }
      //   this.gift_status_change(header)
      // } else if (this.data.transfer_mode == 'Online') {
        
      // }
    }
  }
  pendingRedeem:any;
approvedRedeem:any;
Scanpoints:any;
otherWalletpoints:any;

  getUserEarnPoints() {
    this.serve.post_rqst({'influencer_id':this.user_id}, "Influencer/getRedeemreport").subscribe((response => {
      console.log(response);
      if (response['statusCode'] == 200) {
        this.pendingRedeem = response['pending_points']['pendind_point'];
        this.approvedRedeem =response['approved_points']['approved_point'];
        this.Scanpoints =response['Scan_points']['scan_points'];
        this.otherWalletpoints = response['referral_points']['referral_point'];
      }
      else {
        this.toast.errorToastr(response['statusMsg']);
      }
  
    }));
  }


  purchase_status_change(status,reason) {
    this.savingFlag = true;
    if(status == 'Approved'){
      this.alert.confirm('Are you sure Transfer ?' + this.data.transfer_point +' Point' ).then((result) => {
        if (result) {
          this.serve.post_rqst({ 'status': status, 'influencer_id': Number(this.data.influencerId),'id':Number(this.data.id), 'created_by':Number(this.userId) ,'influencer_type':this.data.influencerType,'transfer_point':this.data.transfer_point}, "RetailerRequest/purchaseStatusChange").subscribe((result => {
            if (result['statusCode'] == 200) {
              this.dialogRef.close(true);
              this.savingFlag = false;
              this.toast.successToastr('Status Changed Successfully');
            }
            else {
              this.toast.errorToastr(result['statusMsg']);
              this.savingFlag = false;
            }

          }))
        }
      });

    }


    else{
      this.serve.post_rqst({ 'status': status, 'influencer_id': Number(this.data.influencerId),'id':Number(this.data.id), 'created_by':Number(this.userId) ,'influencer_type':this.data.influencerType,'status_reason':reason}, "RetailerRequest/purchaseStatusChange").subscribe((result => {

        if (result['statusCode'] == 200) {
          this.dialogRef.close(true);
          this.savingFlag = false;
          this.toast.successToastr('Status Changed Successfully');
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.savingFlag = false;
        }

      }))
    }
  }


  gift_img_Upload(data: any)
  {
      for(let i=0;i<data.target.files.length;i++)
      {
          let files = data.target.files[i];
          if (files)
          {
              let reader = new FileReader();
              reader.onload = (e: any) => {
                  this.data.gift_image = e.target.result
              }
              reader.readAsDataURL(files);
          }
         
          // this.image.append(""+i,data.target.files[i],data.target.files[i].name);
      }
  }

  updatereceived(data){
    this.dialogRef.close(data);


  }


  purchase_Update(product_id,qty,bill_no) {
    this.serve.post_rqst({'product_id': this.data.product_id,'qty':this.data.qty,'purchase_id':this.purchase_id,'bill_no':bill_no,'user_type': this.data.influencerType}, 'RetailerRequest/purchageUpdate').subscribe((result => {
      if (result['statusCode'] == 200){
        this.dialog.closeAll();
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }
    }))
  }


  product_data: any = []
  getProduct(searcValue) {
    // this.data.coupon_type = this.data.coupon_type;
    this.data.product_name = searcValue;
    this.serve.post_rqst({ 'filter': this.data }, 'RetailerRequest/product_list').subscribe((resp) => {
      if (resp['statusCode'] == 200) {
        this.product_data = resp['product_list'];
      }
      else {
        this.toast.errorToastr(resp['statusMsg']);
      }
    }, error => {
    })
  }



  findProductId(code) {
    let index = this.product_data.findIndex(row => row.product_code == code)
    if (index != -1) {
      this.data.product_id = this.product_data[index].product_id;
      this.data.product_name = this.product_data[index].product_name;
      this.data.product_code = this.product_data[index].product_code;
      this.data.mrp = this.product_data[index].mrp;
      this.data.qty = this.product_data[index].qty;
      this.data.point_category_id = this.product_data[index].point_category_id;
      this.data.point_category_name = this.product_data[index].point_category_name;
      this.data.uom = this.product_data[index].uom;
    }
  }
  
}
